function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.267 7.325L8.692 10.91 7.317 9.534a.833.833 0 10-1.175 1.175L8.1 12.675a.831.831 0 00.592.242.833.833 0 00.583-.242l4.167-4.166a.833.833 0 10-1.175-1.184zM10 1.667a8.333 8.333 0 100 16.667 8.333 8.333 0 000-16.667zm0 15a6.667 6.667 0 110-13.334 6.667 6.667 0 010 13.334z",
  fill: "currentColor"
});

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default SvgSuccess;